import React, {useContext, useEffect, useState} from "react"

//Import Css
import './planesPreciosCompt.css'


export function PlanesPreciosCompt({titlePlan, titleTextPlan, textPrecio, textIncluye, iconIncluye, textNoSiIncluye, colorClassName}) {
    
    
    
    // State Animation Planes Precios
    const [animate, setAnimate] = useState(false);

        useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
            setAnimate(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
        }, []);

    
    
    return(

        <div className={`box-planes-precios ${animate ? 'animate' : ''}`}>
                

            <div className="box-title-plan">
                <p className={`title-plan ${colorClassName}`}>{titlePlan}</p>
            </div>

            <div className="box-text-plan">
                <p className="title-text-plan">{titleTextPlan}</p>
            </div>

            <div className="box-precio">
                <p className="text-desde">Desde</p>
                <div className="box-text-precio">
                    <p className="text-precio">{textPrecio}</p>
                    <p className="text-precio-iva">+ Iva.</p>
                </div>
            </div>

            <div className="box-text-incluye">
                <p className="text-incluye">{textIncluye}</p>

            </div>

            {/* LINEA DIVISORIA  */}
            <div className="line-divisor-planes"></div>
            {/* ------------------- */}

            <div className="box-no-si-incluye">

               <img className="icon-incluye-host" alt="Icono Incluye" src={iconIncluye}/> 
               <p className="text-no-si-incluye">{textNoSiIncluye}</p>

            </div>


        </div>

    );
}


